import * as Sentry from '@sentry/browser'
import React, { useEffect, useState } from 'react'
import { flowRight as compose } from 'lodash'
import { useTranslation } from 'react-i18next'

import type { CompanyForFindOne } from 'types'
import {
  CompanyDetail as Content,
  CompanyService,
  initialCompanyDetail,
  renderBreadcrumbsDetail,
} from 'features/Company'
import { Button } from 'components'
import { useBreadcrumbs } from 'helpers/hooks'
import { withBackOfficeCms } from 'helpers/hocs'
import { routes } from 'helpers/routes'
import { RouteChildrenProps } from 'react-router'
import { useParams } from 'react-router-dom'

const CompanyDetail = ({
  history,
  match,
}: RouteChildrenProps<{ id: string }>): JSX.Element => {
  const params = useParams<{ id: string }>()

  const [loading, setLoading] = useState<boolean>(false)
  const [contentData, setContentData] =
    useState<CompanyForFindOne>(initialCompanyDetail)

  const { t } = useTranslation(['layout', 'common'])

  const base = 'con-company'
  const id = match?.params.id || ''

  useEffect(() => {
    getData()
  }, [])

  const getData = async () => {
    try {
      setLoading(true)
      const data = await CompanyService.findOneById(id)
      setContentData(data || initialCompanyDetail)
      setLoading(false)
    } catch (error) {
      Sentry.captureException(error)
    }
  }

  useBreadcrumbs(renderBreadcrumbsDetail(params.id))

  return (
    <div className={`${base}__container ${base}__container-detail`}>
      <Content data={contentData} loading={loading} />
      <div className={`${base}__con-detail-bottom`}>
        <Button
          className={`${base}__form-btn`}
          onClick={() => history.push(`${routes.company.path}/${id}/edit`)}
          variants='primary'
        >
          {t('common:edit.button')}
        </Button>
      </div>
    </div>
  )
}

export default compose(withBackOfficeCms)(CompanyDetail)
